import { Box, Typography } from "@mui/material";
import SpaOutlinedIcon from "@mui/icons-material/SpaOutlined";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import React from "react";

const items = [
  {
    icon: <SpaOutlinedIcon fontSize="inherit" />,
    title: "100% Herbal",
    subtitle: "Ayurvedic formulations",
  },
  {
    icon: <PaymentsOutlinedIcon fontSize="inherit" />,
    title: "Secure Payments",
    subtitle: "Safe & encrypted checkout",
  },
  {
    icon: <VerifiedOutlinedIcon fontSize="inherit" />,
    title: "Trusted Quality",
    subtitle: "Reliable health solutions",
  },
  {
    icon: <SupportAgentOutlinedIcon fontSize="inherit" />,
    title: "Expert Support",
    subtitle: "Help on WhatsApp & phone",
  },
];

const TrustBar = () => (
  <Box className="home-trust">
    <Box className="home-trust-grid">
      {items.map((item) => (
        <Box key={item.title} className="home-trust-item">
          <Box className="home-trust-icon">{item.icon}</Box>
          <Box className="home-trust-copy">
            <Typography component="p" className="home-trust-title">
              {item.title}
            </Typography>
            <Typography component="p" className="home-trust-sub">
              {item.subtitle}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  </Box>
);

export default TrustBar;
